/** PostHog / analytics: which Tablelist surface emitted the event or identify. */
export enum TablelistAnalyticsApp {
  WEB_APP = 'web-app',
  TL_WEB = 'tl-web',
  TL_WEB_LEGACY = 'tl-web_legacy',
  BUY_LEGACY = 'buy_legacy',
  TPRO_MOBILE = 'tpro-mobile',
  TL_MOBILE = 'tl-mobile',
  TPRO_HELP_DOCS = 'tpro-help-docs',
  API = 'api',
}

/** PostHog person property `tablelist_person_type` — consumer vs venue staff. */
export enum TablelistPersonType {
  CONSUMER = 'consumer',
  MANAGEMENT_USER = 'management_user',
}

const MANAGEMENT_DISTINCT_ID_PREFIX = 'management:' as const

/** Stable PostHog distinct_id for management users (avoids id collisions with consumer User docs). */
export function posthogManagementDistinctId(managementUserId: string): string {
  return `${MANAGEMENT_DISTINCT_ID_PREFIX}${managementUserId}`
}
